const { ccclass } = cc._decorator;
import PlayerPaibeiChooseView from "./player_paibei_chooseview";
import ModuleBase, { moduleInit, ViewLayer } from "../../../../../framework/core/mvvm/module_base";
import PlayerSettingChildBase from "../player_setting_childbase";
import CommonSettingItem from "../common_setting_item";
import EventManager from "../../../../../manager/event_manager";
import ModelData from "../../../../public/model_data";

@ccclass
@moduleInit("PlayerPaibeiChoose")
export default class PlayerPaibeiChoose extends PlayerSettingChildBase<PlayerPaibeiChooseView, null>  {
    // lastChooseItem = null
    // lastEqitItem = null
    constructor() {
        super()
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/playerinfosetting/player_paibei_choose";
        this.viewType = PlayerPaibeiChooseView;
    }

    onInit(intentData: any) {
        super.onInit(intentData);
    }

    onShow(intentData) {
        this.showItem(intentData)
    }

    showItem(data){
        let dataCount = data != null ? data.length : 0
        for (let index = 0; index < dataCount; index++) {
            const element = data[index];
            if (this.itemList[index] == null){
                let obj = cc.instantiate(this.view.itemNode)
                this.view.itemGrid.addChild(obj)
                this.itemList[index] = obj.getComponent(CommonSettingItem)
            }
            this.itemList[index].showInfo(element, this)
            if (this.lastChooseItem == null && element.plizedCode == ModelData.instance.roleData.plizedCardIcon){
                super.chooseItem(this.itemList[index])
            }
        }

        if (this.itemList.length > dataCount){
            for (let index = dataCount; index < this.itemList.length; index++) {
                this.itemList[index].showItemInfo(null)
            }
        }
    }

    //切换
    // chooseItem(item){
    //     if (item == null || item.itemData == null){ return }
    //     super.chooseItem(item)
    //     let itemData = item.itemData
    //     if (itemData.isHave){
    //         if (this.lastEqitItem == item) { return }
    //         EventManager.instance.dispatch('Event_Update_Local_Plized', itemData)
    //         item.updateEqit(true)
    //         if (this.lastEqitItem != null){
    //             this.lastEqitItem.updateEqit(false)
    //         }
    //         this.lastEqitItem = item
    //     }
    // }
}